import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_user_by_id = (id) => {
  return api.post(`${ApiEndpointConstants.SHOWUSER}`, {}, { params: { id } });
};
